// extracted by mini-css-extract-plugin
module.exports = {"LoadingIndicator":"LoadingIndicator_LoadingIndicator__kaYfx","DotsFlashing":"LoadingIndicator_DotsFlashing__b6f9_","dotFlashAnimation":"LoadingIndicator_dotFlashAnimation__VhOcW"};